"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NO_ACTIVE_VALUE = exports.INITIAL_LAST_HIGHLIGHT = void 0;
const NO_ACTIVE_VALUE = exports.NO_ACTIVE_VALUE = Symbol('none');
const INITIAL_LAST_HIGHLIGHT = exports.INITIAL_LAST_HIGHLIGHT = {
  value: NO_ACTIVE_VALUE,
  index: -1
};